import api from "@/services/api";

export const state = {
  areaOfOperation: {},
  areasOfOperation: [],
};

export const mutations = {
  INIT_AREA_OF_OPERATION(state, payload) {
    state.areaOfOperation = payload;
  },
  INIT_AREAS_OF_OPERATION(state, payload) {
    state.areasOfOperation = payload;
  },
};

export const actions = {
  getAreaOfOperation({ commit }, payload) {
    api.getAreaOfOperationById(payload).then((response) => {
      commit("INIT_AREA_OF_OPERATION", response.data.data);
    });
  },
  getAreasOfOperation({ commit }, payload) {
    api.getAreaOfOperations(payload).then((response) => {
      commit("INIT_AREAS_OF_OPERATION", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
};

export const getters = {
  getAreaOfOperation: (state) => state.areaOfOperation,
  getAreasOfOperation: (state) => state.areasOfOperation,
};
